// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconMoneybag,
  IconReportMoney
} from "@tabler/icons-react"

// constant
const icons = {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const ConfigPaiements = {
  id: "paements",
  title: ["H. ",<FormattedMessage id="gestion_des_paiements" />],
  type: "group",
  icon: <IconReportMoney />, // Use a valid icon component here

 /*  children: [
    {
      id: "paiements2",
      title: <FormattedMessage id="paiemnts" />,
      type: "collapse",
      icon: IconMoneybag, */
      children: [
        {
          id: "numerobirdereau",
          title: ["1. ", <FormattedMessage id="enregistrer_numero_bordereau" />],
          type: "item",
          url: "/paiements/Bordereau",
        },
        {
          id: "recibo_anulation1",
          title: ["2. ", <FormattedMessage id="recibo_anulation" />],
          type: "item",
          url: "/paiements/BordereauAnulationRecibo",
        },

        {
          id: "mescobranca",
          title: ["3. ", <FormattedMessage id="mescobrabca" />],
          type: "item",
          url: "/paiements/MesCobranca",
        },
       
        {
          id: "type_paiements",
          title: ["4. ", <FormattedMessage id="enregistrer_type_paiements" />],
          type: "item",
          url: "/paiements/ConfigPaiementsg",
        },

        {
          id: 'cadeiraEmAtrasoConfig1',
          title: ["5. ", <FormattedMessage id="cadeiraEmAtrasoConfig" />],
          type: 'item',
          url: '/paiements/CadeiraEmAtrsoConfig'
      },

      {
        id: 'declarations_paiements_configurations1',
        title: ["6. ", <FormattedMessage id="declarations_paiements_configurations" />],
        type: 'item',
        url: '/paiements/EnregistrerTypePaimentAutresFraisDeclarations'
    },
      
        {
          id: "formePayment1",
          title: ["7. ",<FormattedMessage id="formesPayment" />],
          type: "item",
          url: "/paiements/FormesPayment",
        },
        {
          id: "nouveauTypePaiement",
          title: ["8. ", <FormattedMessage id="nouveauTypePaiments" />],
          type: "item",
          url: "/paiements/EnregistrerTypePaiment",
        },
        {
          id: "nouveauTypePaiments_outres_frais1",
          title: ["9. ", <FormattedMessage id="nouveauTypePaiments_outres_frais" />],
          type: "item",
          url: "/paiements/EnregistrerTypePaimentAutresFrais",
        },

       /*  {
          id: "listTypePaiement3s",
          title: ["10. ", <FormattedMessage id="listTypePaiementsEnregistres" />],
          type: "item",
          url: "/paiements/ListTypePaiementEnregistre",
        }, */

        {
          id: "etudiant__en__ordre__paiement1",
          title: ["10. ",<FormattedMessage id="etudiant__en__ordre__paiement" />],
          type: "item",
          url: "/paiements/ListeEtudiantsEnOrdrePaiements",
        },
        {
          id: "etudiant__non__en__ordre__paiement1",
          title: ["11. ", <FormattedMessage id="etudiant__non__en__ordre__paiement" />],
          type: "item",
          url: "/paiements/ListeEtudiantsEnOrdrePasPaiements",
        },

        {
          id: "previsitions_paiement1",
          title: ["12. ", <FormattedMessage id="previsitions_paiement" />],
          type: "item",
          url: "/paiements/PrevisionsRecettes",
        },
        {
          id: "tableauRecapulatifDesPaiements",
          title: ["13. ", <FormattedMessage id="tableau__recapulatid__paiement" />],
          type: "item",
          url: "/paiements/TableauRecapulatifPaiements",
        },

        {
          id: 'soldefinancier1',
          title: ["14. ",  <FormattedMessage id="solde_financier" />],
          type: 'item',
          url: '/paiements/SaldoEstudante',
      },

      {
        id: "multaDesactivar1",
        title: ["15. ", <FormattedMessage id="multaDesactivar" />],
        type: "item",
        url: "/paiements/DesactivarMulta",
      },

      {
        id: "descontos",
        title: ["16. ", <FormattedMessage id="descontos" />],
        type: "item",
        url: "/paiements/Descontos",
      },

      {
        id: "actualizacao_supressao_pagamebnto_obrigatorios1",
        title: ["17. ", <FormattedMessage id="actualizacao_supressao_pagamebnto_obrigatorios" />],
        type: "item",
        url: "/paiements/PagamentosPropinasCadeeirasAtrasoSupressaojs",
      },

      {
        id: "pagamento_adicionar_manuelemente1",
        title: ["18. ", <FormattedMessage id="pagamento_adicionar_manuelemente" />],
        type: "item",
        url: "/paiements/PagamentosPropinaAdicionar",
      },

        {
          id: "paiementDesFrais",
          title: ["19. ", <FormattedMessage id="paiement_des_frais" />],
          type: "item",
          url: "/paiements/PaiementDesFrais",
        },

       
      ],
   // },
 // ],
};

export default ConfigPaiements;
